import {
  sendAnalyticsEvent,
  sendAnalyticsVirtualPageView
} from '../modules/analytics'

/**
 * This will refresh the survey and return to page 1
 * @param {VueSurveyModel} survey The survey.js module
 */
export function refreshSurvey(survey) {
  survey.clear(true, true)
  document.querySelectorAll('.result-box-item').forEach(item => {
    item.classList.remove('hidden', 'active')
    item.innerHTML = ''
  })
  document.getElementById('tag-box').classList.add('hidden')
}

/**
 *
 * @param {VueComponent} self Vue this component
 * @param {array} allQuestions Array of all question
 * @param {array} allSections Array of all section
 * @param {array} surveyData Array with the survey data
 */
export function onCurrentPageChanged(
  self,
  allQuestions,
  allSections,
  surveyData
) {
  self.survey.onCurrentPageChanged.add(function(result, options) {
    const pageName = result.currentPage.name
    sendAnalyticsVirtualPageView(toKebabCase(pageName), pageName)
    const nextButton = document.getElementById('next-button')
    if (nextButton) {
      if (result.data[options.newCurrentPage.name]) {
        nextButton.classList.add('active')
      } else {
        nextButton.classList.remove('active')
      }
    }
    allQuestions.map(question => {
      question['progressStatus'] = false
    })
    allSections.forEach(section => {
      self.progressBarData[section].value = 0
      self.progressBarData[section].progress = 0
    })
    self.isQuestionRequired = options.newCurrentPage.questions[0].isRequired
    if (options.newCurrentPage.questions[0].choices) {
      self.answersOnPage = options.newCurrentPage.questions[0].choices.length
    }
    for (let i = 0; i < self.survey.currentPageNo; i++) {
      allQuestions[i].progressStatus = true
      let currentSection = allQuestions[i].section
      let sectionMaxAnswer = surveyData[0]['pages'].filter(
        page => page.section === currentSection
      ).length
      if (result.data.branche === 'anders') {
        sectionMaxAnswer = sectionMaxAnswer - 1
      }
      self.progressBarData[currentSection].value += 1
      self.progressBarData[currentSection].progress =
        100 / (sectionMaxAnswer / self.progressBarData[currentSection].value)
    }
  })
}

/**
 *
 * @param {VueComponent} self Vue this component
 * @param {function} filterMachines Function filterMachines from filter.js
 * @param {array} machineList The list of all machines
 * @param {array} modalData The list of the data for modal boxes
 */
export function onValueChanged(self, filterMachines, machineList, modalData) {
  self.survey.onValueChanged.add(function(result, options) {
    const selector = document.querySelectorAll(
      ".result-box-item[data-attr-type='" + options.name + "']"
    )[0]
    let data = options.value
    if (typeof data === 'object') {
      let data = [...options.value]
      let removeKey = Object.keys(data).find(
        k => data[k] === 'Noch nicht sicher'
      )
      if (removeKey !== undefined) {
        data.splice(removeKey, 1)
      }
    }
    if (data === 'Noch nicht sicher' || data === 'Egal') {
      data = ''
    }
    if (data) {
      selector.innerHTML = Array.isArray(data) === true ? data.join(', ') : data
    }
    self.machineCounter = filterMachines(result.data, machineList).length
    if (data.length > 0) {
      selector.classList.remove('hidden')
      selector.classList.add('active')
    } else {
      selector.classList.add('hidden')
    }
    if (result.currentPage.questions[0].isAnswered === true) {
      self.selectedAnswers = 1
    } else {
      self.selectedAnswers = 0
    }
    switch (options.question.getType()) {
      case 'radiogroup':
        sendAnalyticsEvent(options.question.name, 'click', options.value)
        if (modalData.trigger[self.survey.currentPageNo]) {
          self.showDefaultModal(
            modalData[modalData.trigger[self.survey.currentPageNo]].text,
            modalData[modalData.trigger[self.survey.currentPageNo]].icon
          )
          self.hideDefaultModal()
        } else {
          self.survey.nextPage()
        }
        break
      case 'checkbox':
        if (window.matchMedia('(max-width: 767px)').matches) {
          document
            .getElementById('next-button')
            .scrollIntoView({ block: 'end', behavior: 'smooth' })
        }
    }
  })
}

/**
 *
 * @param {VueComponent} self Vue this component
 * @param {array} surveyData Array with the survey data
 */
export function onAfterRenderPage(self, tooltipData, tippy) {
  self.survey.onAfterRenderPage.add(function(result) {
    if (result.currentPage.name === 'Postleitzahl') {
      document
        .getElementsByClassName('sv_q_text_root')[0]
        .setAttribute('maxlength', 5)
    }
    if (self.survey.currentPageNo === 1 && document.getElementById('tag-box')) {
      document.getElementById('tag-box').classList.remove('hidden')
    }
    if (result.currentPage.questions[0].isAnswered) {
      self.selectedAnswers = 1
    } else {
      self.selectedAnswers = 0
    }
    document.querySelectorAll('tooltip').forEach(function(tooltip) {
      const type = tooltip.getAttribute('type')
      const radiogroupSelector = tooltip.closest('.sv_q_radiogroup')
      const checkboxSelector = tooltip.closest('.sv_q_checkbox')
      if (radiogroupSelector) {
        radiogroupSelector.setAttribute('tooltip', 'true')
        radiogroupSelector.insertAdjacentHTML(
          'afterend',
          '<span class="tooltip-tippy" id="tooltip-' +
            type +
            '" tooltip-type="' +
            type +
            '"><i class="icon-cma-info"></i></span>'
        )
      } else if (checkboxSelector) {
        checkboxSelector.setAttribute('tooltip', 'true')
        checkboxSelector.insertAdjacentHTML(
          'afterend',
          '<span class="tooltip-tippy" id="tooltip-' +
            type +
            '" tooltip-type="' +
            type +
            '"><i class="icon-cma-info"></i></span>'
        )
      } else {
        tooltip.innerHTML =
          '<span class="tooltip-tippy" id="tooltip-' +
          type +
          '" tooltip-type="' +
          type +
          '"><i class="icon-cma-info"></i></span>'
      }
      tippy('#tooltip-' + type, {
        content: tooltipData[type],
        theme: 'light',
        allowHTML: false,
        arrow: true,
        placement: 'top'
      })
    })
    if(self.survey.currentPageNo === 0) {
      self.preSelectedFirstAnswer()
    }
  })
}

function toKebabCase(str) {
  return str
    .replace('ä', 'ae')
    .replace('Ä', 'ae')
    .replace('ü', 'ue')
    .replace('Ü', 'ue')
    .replace('ö', 'öe')
    .replace('Ö', 'öe')
    .match(/[A-Z]{2,}(?=[A-Z][a-z0-9]*|\b)|[A-Z]?[a-z0-9]*|[A-Z]|[0-9]+/g)
    .filter(Boolean)
    .map(x => x.toLowerCase())
    .join('-')
}
